import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-[scaena-skeleton-shimmer_1.6s_linear_infinite] rounded-xl bg-[linear-gradient(110deg,rgba(228,231,237,0.7)_8%,rgba(255,255,255,0.9)_18%,rgba(228,231,237,0.7)_33%)] bg-[length:200%_100%] bg-[position:200%_0] motion-reduce:animate-none motion-reduce:bg-[position:0_0]",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
